<template>
  <Wrapper>
    <div class="main">
      <BadRequest :lang="lang" v-if="isBadRequest"></BadRequest>
      <InternalServerError
        v-if="isCreateServerError"
        :lang="lang"
      ></InternalServerError>
      <main v-if="!isLoading && !isBadRequest && !isCreateServerError">
        <figure class="draw-loading flex-all-center" v-if="!isDrawingData">
          <img src="../../../../assets/images/loading.gif" alt="loading" />
        </figure>
        <!-- 変換後の保存用画像 -->
        <figure class="download-img" v-if="isDrawingData">
          <img :src="imageDataUrl" alt="" width="100%" />
        </figure>
        <div class="download-sentence" v-if="isDrawingData">
          <small>
            {{ getSentenceCertificate.save[lang] }}
          </small>
        </div>
        <!-- 保存用（画面には表示しない(位置 : -9999px)） -->
        <CertificateWidth1000
          id="js-download"
          class="width1000"
          :dataRunner="dataRunner"
        ></CertificateWidth1000>
      </main>
    </div>
  </Wrapper>
</template>

<script>
import Wrapper from "../../../../components/sp/Wrapper";
import BadRequest from "../../../../components/common/status/BadRequest";
import InternalServerError from "../../../../components/common/status/InternalServerError";
import CertificateWidth1000 from "../../../../components/common/CertificateWidth1000";
import certificate from "../../../../assets/constants/ranking/certificate/certificate";
import html2canvas from "html2canvas";
import { RepositoryFactory } from "../../../../api/RepositoryFactory";

export default {
  data() {
    return {
      isLoading: true,
      isBadRequest: false,
      isCreateServerError: false,
      isDrawingData: false,
      dataRunner: null,
      imageDataUrl: "",
    };
  },
  async mounted() {
    this.dataRunner = "";
    this.isLoading = true;
    // 既存のcanvasタグがある場合は削除
    if (document.querySelector("#canvas-tag")) {
      document.querySelector("#canvas-tag").remove();
    }
    const RankingRepository = RepositoryFactory.get("ranking");
    try {
      const response = await RankingRepository.getRunner({
        event: this.$route.query.event,
        runner: this.$route.query.runner,
        lang: this.lang,
      });
      this.dataRunner = response.data;
      this.isLoading = false;
      this.$nextTick(function () {
        html2canvas(document.getElementById("js-download")).then((canvas) => {
          const tag = document.body.appendChild(canvas);
          tag.id = "canvas-tag";
          tag.classList.add("none");
          const canvasTag = document.getElementById("canvas-tag");
          this.imageDataUrl = canvasTag.toDataURL();
          this.isDrawingData = true;
        });
      });
    } catch (e) {
      if (e.response.status === 400) {
        this.isBadRequest = true;
        return;
      }
      this.isCreateServerError = true;
    } finally {
      this.isLoading = false;
    }
  },
  computed: {
    getSentenceCertificate: function () {
      return certificate;
    },
    lang: function () {
      return this.$store.state.lang;
    },
  },
  components: {
    Wrapper,
    BadRequest,
    InternalServerError,
    CertificateWidth1000,
  },
  name: "Certificate",
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css?family=EB+Garamond");
.main {
  padding: 0 15px;
  position: relative;
  .draw-loading {
    position: absolute;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
  }
  .download-img {
    margin: 60px 0 0 0;
  }
  .download-sentence {
    margin: 32px 0 0 0;
    text-align: center;
  }
  .width1000 {
    top: -9999px;
    left: -9999px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sp/ranking/certificate/Certificate.vue